module.exports = __webpack_public_path__ + "static/media/lyse-interreg-fwv-vertical.71106297.png";